export const CATEGORY_BLOG_LOADER = "CATEGORY_BLOG_LOADER";
export const CATEGORY_BLOG_SUCCESS = "CATEGORY_BLOG_SUCCESS";
export const CATEGORY_BLOG_FAILURE = "CATEGORY_BLOG_FAILURE";
export const CATEGORY_BLOG_RESET = "CATEGORY_BLOG_RESET";
